
export const FRUITS = [
  { id: 0, name: 'Cherry', radius: 15, color: '#ff4d4d', score: 1 },
  { id: 1, name: 'Strawberry', radius: 22, color: '#ff7675', score: 2 },
  { id: 2, name: 'Grape', radius: 30, color: '#a29bfe', score: 4 },
  { id: 3, name: 'Dekopon', radius: 38, color: '#fab1a0', score: 8 },
  { id: 4, name: 'Persimmon', radius: 48, color: '#e17055', score: 16 },
  { id: 5, name: 'Apple', radius: 60, color: '#d63031', score: 32 },
  { id: 6, name: 'Pear', radius: 72, color: '#ffeaa7', score: 64 },
  { id: 7, name: 'Peach', radius: 88, color: '#fd79a8', score: 128 },
  { id: 8, name: 'Pineapple', radius: 105, color: '#fdcb6e', score: 256 },
  { id: 9, name: 'Melon', radius: 125, color: '#55efc4', score: 512 },
  { id: 10, name: 'Watermelon', radius: 155, color: '#00b894', score: 1024 },
];

export const WALL_THICKNESS = 160;
